import { render, staticRenderFns } from "./ConfiguracaoParametros.vue?vue&type=template&id=08344f8c&lang=pug"
import script from "./ConfiguracaoParametros.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoParametros.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoParametros.vue?vue&type=style&index=0&id=08344f8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports